/**
 * Canvas constants: dimensions, aspect ratio, and proportional border radius.
 * Used by the main editor canvas, Review modal preview, SideToggle preview, and TemplatesPanel.
 * Border radius scales with width (25px at 850px); below 600px width it gets a 20% boost for rounder corners.
 */
export const canvasWidth = 850;
export const maxDisplayWidth = 940;
export const canvasAspectRatio = 1.59259259259;

export const canvasBorderRadiusRatio = 25 / canvasWidth;
export const canvasBorderRadiusSmallThreshold = 600;
export const canvasBorderRadiusSmallBoost = 1.2;
export const canvasBorderRadiusPercent = canvasBorderRadiusRatio * 100;

export function getCanvasBorderRadiusPx(width) {
  if (width == null || !Number.isFinite(width)) return 25;
  let ratio = canvasBorderRadiusRatio;
  if (width < canvasBorderRadiusSmallThreshold) {
    ratio *= canvasBorderRadiusSmallBoost;
  }
  return Math.round(width * ratio);
}
